export default {
    GOD:
    {
        value: -1,
        text: 'Wenn die Verspätung/Vorverlegung durch außergewöhnliche Umstände (z.B. außerordentlich schlechtes Wetter, Naturkatastrophen, politische Unruhen, Sicherheitsrisiken) verursacht wurde haben Sie leider keinen Anspruch auf Schadenersatz.'
    },
    TOO_LATE:
    {
        value: -2,
        text: 'Wenn Sie Ihren Flug versäumt haben, weil Sie nicht rechtzeitig beim Check-In oder am Gate waren, haben Sie leider keinen Anspruch auf Entschädigung.'
    },
    SICK_OR_UNSAFE:
    {
        value: -3,
        text: 'Wenn Ihnen die Beförderung berechtigterweise aufgrund von Krankheit bzw. Sicherheitsbedenken verweigert wurde, haben Sie leider keinen Anspruch auf Entschädigung.'
    },
    LIMITATION_PERIOD:
    {
        value: -4,
        text: 'Ihr Datum des Fluges liegt leider schon länger als drei Jahre zurück. Die Verjährungsfrist bei Flugverspätungs-Entschädigungen beträgt drei Jahre und beginnt mit dem Schluss des Jahres, in dem der Flug geendet hat. Leider können wir in diesem Fall also nichts für Sie tun.'
    },
    NO_EU:
    {
        value: 1,
        text: 'Leider haben Sie keinen Anspruch auf Entschädigung, da ihr Flug nicht unter die EU-Fluggastrechteverordnung fällt.'
    },
    DELAY_LESS_THREE_HOURS:
    {
        value: 2,
        text: 'Leider haben Sie keinen Anspruch auf Entschädigung, da Ihre Ankunft weniger als drei Stunden verspätet war.'
    },
    FORWARDED_LESS_ONE_HOUR:
    {
        value: 3,
        text: 'Leider haben Sie keinen Anspruch auf Entschädigung, da Ihr Flug weniger als eine Stunde vorverlegt wurde.'
    },
    toArray()
    {
        return [
            this.GOD,
            this.TOO_LATE,
            this.SICK_OR_UNSAFE,
            this.LIMITATION_PERIOD,
            this.NO_EU,
            this.DELAY_LESS_THREE_HOURS,
            this.FORWARDED_LESS_ONE_HOUR
        ];
    }
}
